import { Map } from 'immutable';

import {
  ContainerEditActionTypes,
  ContainerEditActions,
} from './container-edit.actions';
import { ContainerActions } from './container.actions';
import { CreateOrUpdate } from './create-or-update';

export function noteItemsBeingEditedReducer(
  state: Map<string, CreateOrUpdate>,
  action: ContainerActions | ContainerEditActions,
): Map<string, CreateOrUpdate> {
  switch (action.type) {
    case ContainerEditActionTypes.CANCEL_CREATE_NOTE_ITEM:
    case ContainerEditActionTypes.CANCEL_UPDATE_NOTE_ITEM:
    case ContainerEditActionTypes.CONFIRM_CREATE_NOTE_ITEM:
    case ContainerEditActionTypes.CONFIRM_UPDATE_NOTE_ITEM: {
      const { id } = action.payload;
      return state.remove(id);
    }

    case ContainerEditActionTypes.CREATE_NOTE_ITEM: {
      const { id } = action.payload;
      return state.merge({ [id]: CreateOrUpdate.CREATE });
    }

    case ContainerEditActionTypes.UPDATE_NOTE_ITEM: {
      const { id } = action.payload;
      return state.merge({ [id]: CreateOrUpdate.UPDATE });
    }

    case ContainerEditActionTypes.CONFIRM_DELETE_ITEM: {
      const { item } = action.payload;
      return state.remove(item.id);
    }

    case ContainerEditActionTypes.CONFIRM_DELETE_SECTION: {
      const { descendantItems } = action.payload;
      return state.removeAll(descendantItems);
    }

    default: {
      return state;
    }
  }
}
